module.exports = __webpack_public_path__ + "assets/img/category-o.b828af03.png";